import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { ButtonLink } from '../ui/ButtonLink';
import { ImageSourceBadge } from '../ui/ImageSourceBadge';
import { ReviewNote } from '../ui/ReviewNote';
import { useProjectDrawer } from '../../contexts/ProjectDrawerContext';
import { getProjectById } from '../../data/projects';
import type { Project, Service } from '../../types/content';
export function ServiceSection({
  service,
  reversed
}: {
  service: Service;
  reversed: boolean;
}) {
  const {
    openProject
  } = useProjectDrawer();
  const related = service.relatedProjectIds.map(getProjectById).filter(Boolean) as Project[];
  return <section id={service.id} aria-labelledby={`${service.id}-title`} className={`scroll-mt-[160px] lg:scroll-mt-[200px] py-20 md:py-24 ${reversed ? 'bg-charcoal-950' : 'bg-charcoal'}`} data-id="element-426" data-mp="1ufn0e9t1q7tq">
      <div className="mx-auto grid max-w-site items-start gap-12 px-5 md:px-8 lg:grid-cols-2 lg:gap-16" data-id="element-427" data-mp="3osuzido215l6">
        <div className={`relative lg:sticky lg:top-[220px] ${reversed ? 'lg:order-2' : ''}`} data-id="element-428" data-mp="3tp3glwltb8uz">
          <div className="relative aspect-[4/3] overflow-hidden" data-id="element-429" data-mp="1p6up81jg3g5x">
            <img src={service.image.src} alt={service.image.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-430" data-mp="1l6kjmpzkerrl" />
            <ImageSourceBadge source={service.image.source} className="absolute bottom-3 right-3" data-id="element-431" data-mp="1z0v42v4j3zru" />
          </div>
          <span className="absolute -bottom-2 left-0 h-2 w-1/3 bg-brand-red" aria-hidden="true" data-id="element-432" data-mp="16a3a84axrn7o" />
        </div>

        <div data-id="element-433" data-mp="128rj1uceytxd">
          <h2 id={`${service.id}-title`} className="font-display text-[40px] font-extrabold uppercase leading-[0.92] text-white md:text-[52px]" data-id="element-434" data-mp="1299mpc1eoafb">
            {service.title}
          </h2>
          <p className="mt-6 text-[18px] leading-relaxed text-steel-200" data-id="element-435" data-mp="1b8mxq956h725">{service.overview}</p>

          <h3 className="mt-10 font-display text-[18px] font-bold uppercase tracking-[0.12em] text-brand-light" data-id="element-436" data-mp="2rmwlb11lirrx">Scope</h3>
          <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-437" data-mp="2mn9wrvgbhp3t">
            {service.scope.map(item => <li key={item} className="flex gap-3 text-[15px] leading-relaxed text-steel-100" data-id="element-438" data-mp="2uo98vy58qy81">
                <span className="mt-2 h-2 w-2 shrink-0 bg-brand-red" aria-hidden="true" data-id="element-439" data-mp="2ypb5063v2u5s" />
                {item}
              </li>)}
          </ul>

          {service.reviewNote && <ReviewNote className="mt-6" data-id="element-440" data-mp="38nqzmj23klk1">{service.reviewNote}</ReviewNote>}

          {related.length > 0 && <>
              <h3 className="mt-10 font-display text-[18px] font-bold uppercase tracking-[0.12em] text-brand-light" data-id="element-441" data-mp="2b2mit87tkfjd">
                Related projects
              </h3>
              <ul className="mt-3 border-t border-white/10" data-id="element-442" data-mp="2kyy2ij9qo7nu">
                {related.map(project => <li key={project.id} className="border-b border-white/10" data-id="element-443" data-mp="2pqzh4budqah1">
                    <button type="button" onClick={event => openProject(project.id, event.currentTarget)} className="group flex w-full items-center justify-between gap-4 py-3.5 text-left" data-id="element-444" data-mp="1sb26zhvwolsn">
                      <span data-id="element-445" data-mp="1kr19t001ntnv">
                        <span className="block text-[16px] font-semibold text-white group-hover:text-brand-light" data-id="element-446" data-mp="1kqrh34nm78eh">{project.title}</span>
                        {project.location && <span className="block text-sm text-steel-400" data-id="element-447" data-mp="1ftrej3pz4ns4">{project.location}</span>}
                      </span>
                      <ArrowRightIcon className="h-4 w-4 shrink-0 text-steel-300 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-448" data-mp="16rrwc8383dnl" />
                    </button>
                  </li>)}
              </ul>
            </>}

          <ButtonLink to={`/contact?service=${service.id}#enquiry`} showArrow className="mt-10" data-id="element-449" data-mp="s2dnr27h1099">
            Discuss This Service
          </ButtonLink>
        </div>
      </div>
    </section>;
}